"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestStatusBoxes = void 0;
var React = require("react");
var status_1 = require("@caddigital/sok-reducers/lib/status");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var LOCALIZATION_KEY_PREFIX = 'userSettingsModal/step3';
var STATUS_LIST = [
    status_1.RequestStatusValue.STANDBY,
    status_1.RequestStatusValue.BUSY,
    status_1.RequestStatusValue.SUCCESS,
    status_1.RequestStatusValue.FAILURE
];
var localizeStatus = function (infix, status) { return (0, translation_1.getLocalization)("".concat(LOCALIZATION_KEY_PREFIX, "/").concat(infix, "/").concat(status)); };
var component = function (props) {
    var boxes = [
        {
            status: props.authenticationCode,
            key: 'sendAuthentication'
        },
        { status: props.company, key: 'changeCompany' },
        { status: props.consents, key: 'updateConsents' },
        { status: props.email, key: 'changeEmail' },
        { status: props.passwordReset, key: 'resetPassword' },
        { status: props.profile, key: 'updateProfile' },
        { status: props.removal, key: 'removeUser' }
    ];
    return (React.createElement(React.Fragment, null, boxes.map(function (_a) {
        var status = _a.status, key = _a.key;
        return status.isUpdate && (React.createElement(sok_ui_1.RequestStatusBox, { key: "request-status-box-".concat(key), status: status.value, statusList: STATUS_LIST },
            localizeStatus(key, 'sending'),
            localizeStatus(key, 'success'),
            localizeStatus(key, 'failed')));
    })));
};
exports.RequestStatusBoxes = component;
